import { createAction, props } from '@ngrx/store';
import { SeStepperSideNavComponentType } from "../se-stepper-side-nav.models";
import { DeepPartial } from '../../utils/types';
import { SeStepperSideNavParentState } from "./se-stepper-side-nav.state";

export enum SeStepperSideNavChildrenActions {
    SET_PATIENT = '[SeStepperSideNavDetailsComponent] SetPatient',
    SET_EXAMS = '[SeStepperSideNavExamsComponent] SetExams',
    REMOVE_EXAMS = '[SeStepperSideNavExamsComponent] RemoveExams',
    SET_ACTIVE_COMPONENTS = '[SeStepperSideNavComponent] SetActiveComponents',
    NO_RESULT = '[SeStepperSideNavComponent] NoResult',
}

export enum SeStepperSideNavParentActions {
    SET_ACTIVE_COMPONENTS = '[SeStepperSideNavComponent] SetActiveComponents',
}


//children actions
export const seStepperSideNavSetPatient =
    createAction(SeStepperSideNavChildrenActions.SET_PATIENT, props<{ patientId: string}>());

export const seStepperSideNavNoResult =
    createAction(SeStepperSideNavChildrenActions.NO_RESULT, props<{ message: string }>());

export const seStepperSideNavSetExams =
    createAction(SeStepperSideNavChildrenActions.SET_EXAMS, props<{ examId : string; }>());

export const seStepperSideNavRemoveExams =
    createAction(SeStepperSideNavChildrenActions.REMOVE_EXAMS, props<{ examId : string; }>());


//parent actions
export const seStepperSideNavComponentSetActiveComponents =
    createAction(SeStepperSideNavParentActions.SET_ACTIVE_COMPONENTS, props<{
        activationList : SeStepperSideNavComponentType[],
        customProps ?: DeepPartial<SeStepperSideNavParentState>;
    }>());
